export default __webpack_public_path__ + "static/media/airdockz-bpk-banner-3.d2211f4c.jpg";